import { Dispatch } from "redux";
import { fetchError, fetchStart, fetchSuccess } from "./Common";
import jwtAxios from "../../@crema/services/auth/jwt-auth";
import { AppActions } from "types";
import { GET_SYNC_GIS, GET_SYNC_PLAN } from "types/actions/syncMaster.action";


export const getAllSyncPlan = () => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    return jwtAxios
      .get(`/plans/sync`)
      .then((response) => {
        if (response.status === 200 && response.data.status === "success") {
          dispatch(fetchSuccess());
          return { success: true }; 
        } else {
          dispatch(fetchError("Something went wrong, please try again!"));
          return Promise.reject("Failed to sync plans");
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
        return Promise.reject(error);
      });
  };
};

export const getAllSyncGIS = () => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    return jwtAxios
      .get(`/area/gis/sync`)
      .then((response) => {
        if (response.status === 200 && response.data.status === "success") {
          dispatch(fetchSuccess());
          
          return { success: true }; 
        } else {
          dispatch(fetchError("Something went wrong, please try again!"));
          return Promise.reject("Failed to sync GIS");
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
        return Promise.reject(error);
      });
  };
};